export enum EditorInitCommands {
  AiAssistant = 'ai-assistant'
}
